import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Table from "../../Components/Table";
import {
	CardBody, Button, Col, Row
} from 'reactstrap';
import { Icon } from "semantic-ui-react"
import { Transfer } from "antd";
import TemplateForm from "./Forms/template";
import { connect } from 'react-redux';
import Axios from 'axios';
import Swal from 'sweetalert2';

import Loader from '../../../Global/Loader';
import ContentWrapper from '../../../template/Layout/ContentWrapper';
import Notification from '../../../Global/Alert';

import { Services } from "../../../../repositories/clients/Services";
import { withNamespaces } from 'react-i18next';


class InfoAlert extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isMovil: false,
			tableEntityConf: [
				// { label: "ID", key: "EntityId" },
				{ label: "ID", key: "EntityId" },
				{ label: this.props.t("company_name"), key: "Name" },
				{ label: this.props.t("phone"), key: "Telephone" },
				{ label: this.props.t("country"), key: "Country" },
			],
			alertId: this.props.match ? this.props.match.params.id : -1,
			loadingInfo: true,
			entityTable: "",
			entityCatalog: [],
			selectedEntities: [],
			data: {}
		}
	}


	componentDidMount = () => {

		let details = navigator.userAgent;
		let regexp = /android|iphone|kindle|ipad/i;
		let isMobileDevice = regexp.test(details);
		
		this.setState({
			isMovil: isMobileDevice
		})


		this.init();
	}

	init = async () => {
		await this.getAlertInfo();
		await this.getEntityCatalog();
		await this.generateInfo();

		this.setState({ checkedList: [], modalIsOpen: false, loadingInfo: false })
	}

	sendMessage = (text, type) => {
		Swal.fire({
			// icon: type,
			confirmButtonColor: "#0060a8",
			confirmButtonText: "Ok",
			customClass: "small-swal",
			html: `<div class="text-center" style="margin-top: 35px">
      ${text}
      </div>`,
		});
	}

	generateInfo = async () => {
		let { data, entityTable, generalInfo, selectedEntities } = this.state;
		if (data) {
			if (data.CustomersId) {
				entityTable = this.generateEntityTable(data.CustomersId.split(","));
				selectedEntities = data.CustomersId.split(",").map((cust) => { cust = parseInt(cust); return cust; });

			}
			generalInfo = this.generateGeneralInfo(data);
		}
		this.setState({ entityTable, generalInfo, selectedEntities });
	}

	generateGeneralInfo = (data) => {

		let generalInfo = TemplateForm["previewForm"].map((e) => {
			var attrInfo = "";
			var extraClass = "";

			if (e.type === "label") {
				attrInfo = <span className="tag-custom-value">{data[e.id]}</span>;
			}
			return (
				<div className={e.class} style={{ paddingTop: "1%" }}>
					{
						<div className="row">
							<div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
								<span className="title-custom-value" style={{ fontWeight: "bold" }}>{this.props.t(e.label)}</span>
							</div>
							<div className={"col-md-12 col-lg-12 col-sm-6 " + extraClass}>
								{attrInfo}
							</div>
						</div>
					}
				</div>
			);
		});
		return generalInfo;
	};

	getAlertInfo = async () => {
		let { data, alertId } = this.state;
		try {
			let res = await Axios.get(`${Services.ADMIN.path}alerts/getInfoAlert/${alertId}`)
			data = res.data.alert;

			this.setState({ data });
		} catch (ex) {
			console.error(ex);
		}
	}

	getEntityCatalog = async () => {
		// let { entityCatalog } = this.state;
		try {
			let resp = await Axios.get(`${Services.ADMIN.path}admin/entities`);
			// entityCatalog = this.sortCatalogs(resp.data.clientes, "text");
			this.setState({ entityCatalog: resp.data.clientes });
		} catch (ex) {
			console.error(ex);
		}

	}

	generateEntityTable = (EntitiesIds) => {
		let { entityCatalog } = this.state;
		var arrayEntity = [];
		EntitiesIds.forEach((entId) => {
			entityCatalog.forEach((catEnt) => {
				if (entId === catEnt.key) {
					arrayEntity.push(catEnt.data);
				}
			});
		});
		arrayEntity.sort((a, b) => a.Name.localeCompare(b.Name));

		return (
			<div className='col-12'>
				<Table
					columns={this.state.tableEntityConf}
					data={arrayEntity}
					itemsByPage={5}
					rowClick={false}
					options={{
						large: true,
						downloads: {
							pdf: false,
							xlsx: false,
						},
						pagination: true,
						search: true,
					}}
				/>
			</div>

		);
	};
	cambiaEdicion = () => {
		let { data, selectedEntities } = this.state;
		this.setState({
			loadingInfo: true
		})
		if (data) {
			if (data.CustomersId) {
				selectedEntities = data.CustomersId.split(",").map((cust) => { cust = parseInt(cust); return cust; });
			}
		}
		this.setState({ isEdit: true, selectedEntities });

		setTimeout(() => {
			this.setState({
				loadingInfo: false
			})
		}, 2000);
	}

	//### Agregar o desasignar #########

	sortCatalogs = (array, attr) => {
		array.sort((a, b) => a[attr].localeCompare(b[attr]))
		return array;
	}
	filterOption = (a, b, c) => {
		return b.label.toLowerCase().indexOf(a.toLowerCase()) > -1;
	};

	cancelEdit = () => {
		let { data } = this.state;
		this.setState({ isEdit: false, selectedEntities: data.CustomersId.split(",") })
	}
	sleep = (milliseconds) => {
		return new Promise((resolve) => setTimeout(resolve, milliseconds));
	};
	saveEdit = async () => {
		let { selectedEntities, alertId } = this.state;
		let data = {
			AlertId: alertId,
			Entities: selectedEntities
		}
		try {
			this.setState({ loadingInfo: true }, async () => {
				await Axios.put(`${Services.ADMIN.path}alerts/editAlert`, data);

				Notification(this.props.t("updated"), this.props.t("alert_update_succesful"), 'success');
				this.sleep(1500).then(() => {
					this.props.history.push("/alerts-and-notifications");
				});
			})

		} catch (ex) {
			console.error(ex);
		}
	}


	onlyUnique = (value, index, self) => {
		return self.indexOf(value) === index && value != null && value !== "";
	};


	handleChangeFilter = (nextTargetKeys, direction, moveKeys) => {
		let { selectedEntities } = this.state;
		if (selectedEntities) {
			if (direction === "left") {
				moveKeys.forEach((key) => {
					var removeKey = selectedEntities.indexOf(key);
					if (removeKey > -1) {
						selectedEntities.splice(removeKey, 1);
					}
				});
				this.sendMessage(this.props.t("retired"), "info");
			} else {
				moveKeys.forEach((key) => {
					selectedEntities.push(key);
				});
				this.sendMessage(this.props.t("added"), "info");
			}

			selectedEntities = selectedEntities.filter(this.onlyUnique);
		} else {
			this.sendMessage(this.props.t("added"), "info");
			selectedEntities = moveKeys;
		}

		this.setState({ selectedEntities });
	};
	//###################################

	/*=============================================
	=            Render Method                    =
	=============================================*/

	render() {
		let { isEdit, loadingInfo, entityTable, generalInfo, entityCatalog, selectedEntities, isMovil } = this.state;
		console.log("selectedEntities", selectedEntities);
		console.log("entityCatalog", entityCatalog);
		return loadingInfo ? (
			<Loader />
		) : (
			<ContentWrapper>
				<div className="content-heading">
					{/* <Row> */}
					<legend className="legendBasic">
						<i className="far fa-bell mr-2"></i>


						{/* <img
							style={{ margin: '-6px 6px 1px' }}
							alt=""
							src="https://magiclog.blob.core.windows.net/europartnerspic/Icono_notificacion.svg"
							height="28"
							width="28"
						></img> */}
						{this.props.t("alert_notifications")}
					</legend>
					<div className="_btnBack d-flex align-items-center">
						<Icon.Group>
							<Icon name='angle left'
								onClick={() => this.props.history.push('/alerts-and-notifications')}
							/>
						</Icon.Group>
						<span className="_text_btn-back"
							onClick={() => this.props.history.push('/alerts-and-notifications')}>
							{this.props.t("back")}
						</span>
					</div>
					{/* </Row> */}
				</div>
				<Row>
					<Col xs={12}>
						<div className={!isMovil ? 'card myCard' : ''}>
							<CardBody>
								<div className="row">
									<div className="col-8">
										<h4 className="title-obl">
											{this.props.t("alert_detail")}
										</h4>
									</div>
									<div className="col-4">
										{isEdit ? false :
											<em
												style={{ fontSize: "25px", marginRight: "10px" }}
												className="fas fa-pencil-alt clickable float-right"
												onClick={() => this.cambiaEdicion()}
												title={this.props.t("edit")}
											></em>
										}

									</div>
								</div>
								<div className='col-12 row' style={{ marginTop: "35px" }}>
									{generalInfo}
								</div>
								{isEdit ? <div>
									{/* <div className='row'> */}
									<Transfer
										style={{
											marginTop: "25px",
											width: "100%",
											// maxWidth: "90%",
											justifyContent: "center",
											height: "350px",
										}}
										locale={{
											itemUnit: this.props.t("customers"),
											itemsUnit: this.props.t("customers"),
											searchPlaceholder: "",
										}}
										dataSource={this.state.entityCatalog}
										showSearch
										filterOption={this.filterOption}
										onChange={this.handleChangeFilter}
										render={(item) => item.label}
										operations={[this.props.t("add"), this.props.t("eliminate")]}
										targetKeys={selectedEntities}

									// showSelectAll={false}
									/>
									{/* </div> */}
									<div className='row' style={{ marginTop: "15px" }}>
										<div className='col-6'>
											<Button
												// style={{ marginLeft: "10px" }}
												variant="contained"
												// disabled={!(selectedEntities && selectedEntities.length > 0)}
												color="primary"
												className="button float-right"
												onClick={this.saveEdit}
											>
												{this.props.t("save")}
											</Button>
										</div>
										<div className='col-6'>
											<Button
												variant="contained"
												style={{
													backgroundColor: "#020e3a",
												}}
												color="secondary"
												className="button float-left"
												onClick={this.cancelEdit}
											>
												{this.props.t("cancel")}
											</Button>
										</div>
									</div>
								</div> :
									<div style={{ marginTop: "45px" }}>{entityTable}</div>
								}

								{/* </div> */}
							</CardBody>
						</div>
					</Col>
				</Row>
			</ContentWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withNamespaces()(withRouter(InfoAlert)));
